import React, {useRef, useState} from "react";
import {connect, useSelector} from "react-redux";

// components
import CategoryForm from "./_categoryForm";
import {getStateByPath} from "../../../../redux/selectors";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {DragDropList} from "../../../../components/draggableList/DragDropList";

// label
import {TT_EDIT} from "../../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem} from "../../../../redux/actions/generics/IndexedActions";

// services
import {categoryUdnService} from "../../../../jwt/_services/park/DynamicModuleService";
import Loading from "../../../../components/loader/Loading";






const ListCategoryComponent = props => {
    const {mainPath, categoriesPath} = props
    const udnState = useSelector(state => getStateByPath(state, mainPath));
    const categoriesState = useSelector(state => getStateByPath(state, categoriesPath));

    const { app:{ fbDataBase } } = udnState?.data || {};
    const { listDomainObjects:categoriesLinkedToUdn } = categoriesState?.data || {};


    const [categorySelected, setCategorySelected] = useState(null)
    const [deletingCategoryId, setDeletingCategoryId] = useState(null); // Estado para rastrear el elemento en eliminación

    const categoryFormModalRef = useRef(null);


    const unLinkCategory = async categoryUdnId => {
        setDeletingCategoryId(categoryUdnId);
        await genericIndexedActions.delete(categoriesPath, categoryUdnService, categoryUdnId, fbDataBase?.id, ()=> setDeletingCategoryId(null))
    }



    const editActivity = data => {
        props.setItem(categoriesPath, data);
        props.setForm(categoriesPath, true, false, false);

        categoryFormModalRef.current.showModal();
    }

    const onSelectCategory = (categoryLinkedToUdn, index) => {
        setCategorySelected(index)
        props.setItem(categoriesPath, categoryLinkedToUdn?.category)
    }


    const renderContent = (categoryLinkedToUdn, index) => <div
        key={categoryLinkedToUdn?.id}
        onClick={() => onSelectCategory(categoryLinkedToUdn, index)}
        className={`sub-category-item  ${ categorySelected === index ? 'xwitch-checked' : 'xwitch-unchecked'} d-flex align-items-center justify-content-between p-2`}
    >
        {
            //Muestra el componente Loading solo si el elemento actual está siendo eliminado
            deletingCategoryId === categoryLinkedToUdn?.id && <Loading isLoading={true} showTitle={false}/>
        }

            <label> {categoryLinkedToUdn?.category?.name} </label>

            {
                categorySelected === index && <GenericButton
                    style={'table'}
                    toolTip={TT_EDIT}
                    icon={'fa-pen'}
                    permission={'edit'}
                    onClick={e => {
                        e.stopPropagation();
                        editActivity(categoryLinkedToUdn?.category)
                    }}
                />
            }

            <GenericButton
                style={'danger-secondary'}
                toolTip={'Desvincular de la UDN'}
                icon={'fa-chain-broken'}
                permission={'edit'}
                onClick={e => {
                    e.stopPropagation();
                    unLinkCategory(categoryLinkedToUdn?.id)
                }}
            />
    </div>


    return <div className={'sauser-container'}>
        <DragDropList
            items={categoriesLinkedToUdn?.sort((a, b) => a?.showOrder - b?.showOrder)}
            renderContent={renderContent}
            onReorder={()=> console.info('reorder not implemented')}
            orientationHV={'horizontal-container'}
            className="flex-wrap-container"
        />

        <CategoryForm
            ref={categoryFormModalRef}
            mainPath={mainPath}
            categoriesPath={categoriesPath}
        />
    </div>

}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(ListCategoryComponent);